export default __webpack_public_path__ + "static/media/call.65f50942.svg";